









import {Component, Vue, Watch} from 'vue-property-decorator'
import ButtonCommon from '@/components/lib/ButtonCommon.vue'
import InputSelect from '@/components/lib/InputSelect.vue'
import InputToggle from '@/components/lib/InputToggle.vue'
import IconCustom from '@/components/lib/IconCustom.vue'
import {IOption, ISort, Sort} from '@/components/lib/models'

@Component({
  components: {
    ButtonCommon,
    InputSelect,
    InputToggle,
    IconCustom
  }
})
export default class TravelOrdering extends Vue {

  private sorting: ISort = new Sort({
    field: this.orderingFields[0].value
  })

  get orderingFields(): IOption<string>[] {
    return [
      {
        name: this.$t('ordering.by.name') as string,
        value: 'name'
      }, {
        name: this.$t('ordering.by.price') as string,
        value: 'price'
      }, {
        name: this.$t('ordering.by.tourist') as string,
        value: 'tourist_min'
      }, {
        name: this.$t('ordering.by.date') as string,
        value: 'date_creation'
      }
    ];
  }

  get orderingDirections(): IOption<string>[] {
    return [
      {
        name: this.$t('ordering.direction.direct') as string,
        value: 'direct'
      }, {
        name: this.$t('ordering.direction.reverse') as string,
        value: 'reverse'
      }
    ];
  }

  @Watch('sorting', { deep: true })
  protected onSortingChanged(): void {
    this.$emit('update:sorting', this.sorting);
  }

}
